import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface IScheduleChangesStore {
	/** A schedule push arrived, so the recorded changes may be shown. */
	isShowRequested: boolean;

	setShowRequested: (isShowRequested: boolean) => void;
	reset: () => void;
}

const initialState = {
	isShowRequested: false,
};

/** Persisted, so a push tapped from a killed app still opens the changes. */
export const useScheduleChangesStore = create<IScheduleChangesStore>()(
	persist(
		(set) => ({
			...initialState,

			setShowRequested: (isShowRequested) => set({ isShowRequested }),
			reset: () => set(initialState),
		}),
		{
			name: 'scheduleChangesStorage',
		}
	)
);
